import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CrudService } from './crud.service';
import { HttpClient } from '@angular/common/http';
import { ICancellableCrud } from 'projects/common/src/app/interfaces/communication';
import { IRequestConfig, IRequestCancellable } from 'projects/common/src/app/interfaces/communication/request';
import { ServerConfigService } from 'src/app/services/server-config.service';

@Injectable({
  providedIn: 'root'
})
export class CancellableCrudService extends CrudService implements ICancellableCrud {

  constructor(
    protected http: HttpClient,
    protected configServer: ServerConfigService
  ) {
    super(http, configServer);
  }

  public getCancellable(
    endPoint: string,
    parameters?: {[key: string]: string},
    config: IRequestConfig = {},
    apply?: (arg0: any) => any,
  ): IRequestCancellable {
    const cancellableObservable: Subject<any> = new Subject<any>();
    const source = this.get(endPoint, parameters, config, apply).pipe(
      takeUntil(cancellableObservable)
    );
    return {
      source,
      cancel: () => this.cancel(cancellableObservable),
    };
  }

  public postCancellable(
    endPoint: string,
    body: any,
    parameters?: {[key: string]: string},
    config?: IRequestConfig,
    apply?: (arg0: any) => any
  ): IRequestCancellable {
    const cancellableObservable: Subject<any> = new Subject<any>();
    const source = this.post(endPoint, body, parameters, config, apply, cancellableObservable).pipe(
      takeUntil(cancellableObservable)
    );
    return {
      source,
      cancel: () => this.cancel(cancellableObservable),
    };
  }

  public patchCancellable(
    endPoint: string,
    body: any,
    config?: IRequestConfig,
  ): IRequestCancellable {
    const cancellableObservable: Subject<any> = new Subject<any>();
    const source = this.patch(endPoint, body, config).pipe(
      takeUntil(cancellableObservable)
    );
    return {
      source,
      cancel: () => this.cancel(cancellableObservable),
    };
  }

  public deleteCancellable(
    endPoint: string,
    config?: IRequestConfig
  ): IRequestCancellable {
    const cancellableObservable: Subject<any> = new Subject<any>();
    const source = this.delete(endPoint, config).pipe(
      takeUntil(cancellableObservable)
    );
    return {
      source,
      cancel: () => this.cancel(cancellableObservable),
    };
  }

  /**
   * Completa un observable entregada por parámetro
   * @param observable observable que se cancelará
   */
  private cancel(observable: Subject<void>): void {
    if (observable) {
      observable.next();
      observable.complete();
    }
  }
}
